import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {
  FaRocket,
  FaHandshake,
  FaShieldAlt,
  FaNetworkWired,
  FaPlay,
  FaFlagCheckered,
} from 'react-icons/fa';

const Roadmap = () => {
  const milestones = [
    {
      title: 'Q1 2026',
      description: 'Mining has started — mainnet mining live and initial community miners onboarded. DOLP emissions begin.',
      icon: <FaPlay />,
    },
    {
      title: 'Q2 2026',
      description: 'Pre‑sale & referral rollout completed; referral dashboard and tokenomics updates for DOLP live.',
      icon: <FaHandshake />,
    },
    {
      title: 'Q3 2026',
      description: 'Audit completed and secure contracts deployed for DOLP; bug bounty program launched to harden security.',
      icon: <FaShieldAlt />,
    },
    {
      title: 'Q4 2026',
      description: 'Cross‑chain expansion and ecosystem partnerships to grow DOLP liquidity and integrations.',
      icon: <FaNetworkWired />,
    },
    {
      title: 'Q4 2026 (End of Mining)',
      description: 'End of mining — DOLP token emissions conclude; final mining rewards distributed; transition to community governance and staking incentives.',
      icon: <FaFlagCheckered />,
    },
    {
      title: 'Late 2026',
      description: 'Governance handover, staking programs launch, and ongoing security monitoring for the DOLP ecosystem.',
      icon: <FaRocket />,
    },
  ];

  return (
    <section
      style={{
        padding: '4rem 1rem',
        background: 'linear-gradient(120deg, #e0f7fa, #e1bee7)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '2rem',
          color: '#23263a',
          fontWeight: 'bold',
          textShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        Roadmap 2026
      </h2>

      <VerticalTimeline>
        {milestones.map((milestone, index) => (
          <VerticalTimelineElement
            key={index}
            date={milestone.title}
            iconStyle={{
              background: index % 2 === 0 ? '#38bdf8' : '#a78bfa',
              color: '#fff',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            }}
            contentStyle={{
              background: '#ffffff',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              padding: '1.5rem',
            }}
            contentArrowStyle={{ borderRight: '7px solid #ffffff' }}
            icon={milestone.icon}
          >
            <h3
              style={{
                color: '#23263a',
                fontSize: '1.25rem',
                fontWeight: '700',
                marginBottom: '0.5rem',
              }}
            >
              {milestone.title}
            </h3>
            <p
              style={{
                color: '#6b7280',
                fontSize: '1rem',
                lineHeight: 1.6,
                margin: 0,
              }}
            >
              {milestone.description}
            </p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>

      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background:
            'url("https://www.transparenttextures.com/patterns/diagonal-noise.png")',
          opacity: 0.18,
          pointerEvents: 'none',
        }}
      />
    </section>
  );
};

export default Roadmap;
